import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function EyeNoneMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M20.712 22.008l1.296-1.296-18.72-18.72-1.296 1.296 3.624 3.624A14.46 14.46 0 001.68 12c2.04 4.392 6.336 7.68 10.32 7.68 1.632 0 3.312-.552 4.872-1.512l3.84 3.84zM3.696 12c.84-1.512 1.872-2.784 3.192-3.816L8.904 10.2A3.339 3.339 0 008.4 12c0 1.992 1.608 3.6 3.6 3.6.648 0 1.272-.168 1.8-.504l1.752 1.752c-1.176.696-2.328 1.032-3.552 1.032-3.144 0-6.384-2.304-8.304-5.88zm5.232-7.08l1.392 1.416A6.722 6.722 0 0112 6.12c3.096 0 6.264 2.28 8.208 5.88a13.53 13.53 0 01-1.728 2.496l1.296 1.296A15.215 15.215 0 0022.32 12C20.28 7.608 15.984 4.32 12 4.32c-1.032 0-2.064.216-3.072.6zM10.08 12c0-.192.024-.36.072-.552l2.4 2.4c-.192.048-.36.072-.552.072A1.926 1.926 0 0110.08 12z"  /></Svg>;
}
export default EyeNoneMedium;